import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-8 text-center">
            プライバシーポリシー
          </h1>
          
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl">
            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. 個人情報の取り扱いについて</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  株式会社Dream Sakura（以下「当社」）は、Smart Mates for Sales（以下「本サービス」）において、お客様の個人情報を適切に取り扱います。
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. 無料体験に関する取り扱い</h2>
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">無料体験期間</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    本サービスでは、<s>14日間</s>今だけ２か月の無料体験期間を提供しています。
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    無料体験期間中は、ビジネスプランの全機能をお試しいただけます。
                  </p>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-2 mt-6">無料体験中のデータ収集・利用目的</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  無料体験期間中に収集するデータは、以下の目的で利用します：
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 ml-4">
                  <li>サービスの提供・改善</li>
                  <li>お客様へのサポート対応</li>
                  <li>サービスに関するお知らせ</li>
                  <li>利用状況の分析・統計</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-900 mb-2 mt-6">無料体験終了後のデータ保持期間</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  無料体験を解約された場合でも、以下のデータは一定期間保持いたします：
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 ml-4">
                  <li>会話履歴：1年間</li>
                  <li>営業レポート：1年間</li>
                  <li>統計データ：1年間</li>
                  <li>アカウント情報：解約後30日間</li>
                </ul>
                <p className="text-gray-700 leading-relaxed">
                  保持期間経過後は、適切に削除いたします。
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. クレジットカード情報の取り扱い</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  無料体験開始時には、クレジットカード情報の登録が必要です。ただし、無料体験期間中（<s>14日間</s>今だけ２か月）は一切の請求は行われません。
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  クレジットカード情報は、決済代行業者であるStripe社が管理します。当社はクレジットカード情報を直接保持することはありません。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Stripe社のプライバシーポリシーについては、<a href="https://stripe.com/jp/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">こちら</a>をご確認ください。
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. 収集する個人情報</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  本サービスでは、以下の個人情報を収集します：
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 ml-4">
                  <li>会社名、お名前、メールアドレス（登録時）</li>
                  <li>Googleアカウント情報（Google ID、メールアドレス、プロフィール画像など）</li>
                  <li>会話履歴（チャット内容）</li>
                  <li>営業レポート（自動生成）</li>
                  <li>統計データ（業種、企業規模、地域など）</li>
                  <li>利用状況（アクセスログ、機能利用状況など）</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. 個人情報の利用目的</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  収集した個人情報は、以下の目的で利用します：
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 ml-4">
                  <li>本サービスの提供・運営</li>
                  <li>Googleアカウントによる認証・ログイン</li>
                  <li>お客様へのサポート対応</li>
                  <li>サービス改善のための分析</li>
                  <li>新機能・サービスのご案内</li>
                  <li>不正利用の防止</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. 個人情報の第三者提供</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません：
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 ml-4">
                  <li>お客様の同意がある場合</li>
                  <li>法令に基づく場合</li>
                  <li>人の生命、身体または財産の保護のために必要な場合</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. 個人情報の管理</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  当社は、お客様の個人情報を適切に管理し、漏洩、滅失、毀損の防止に努めます。
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. お問い合わせ</h2>
                <p className="text-gray-700 leading-relaxed">
                  個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください。
                </p>
                <p className="text-gray-700 leading-relaxed mt-4">
                  SmartMatesサポート<br />
                  メール: <a href="/?page=contact" className="text-blue-600 hover:text-blue-800 underline">support@smartmates.org</a>
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. プライバシーポリシーの変更</h2>
                <p className="text-gray-700 leading-relaxed">
                  当社は、必要に応じて本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、本ページに掲載した時点で効力を生じるものとします。
                </p>
              </section>

              <div className="mt-12 pt-8 border-t border-gray-200 text-center">
                <p className="text-gray-500 text-sm">
                  制定日: 2025年1月28日
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;








